import { Component } from "react";


class About extends Component {
    render() { 
        return (
            <section className="about padding-top padding-bottom">
                <div className="container">
                    <div className="about__wrapper">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <div className="about__thumb" data-aos="fade-up" data-aos-duration="1500">
                                    <img src="assets/images/about/01.png" alt="About Image" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about__content" data-aos="fade-up" data-aos-duration="2000">
                                    <h2>7777 Unique NFT Herox</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia wiat consectetur adipisicing elitRe.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia wiat consectetur adipisicing elitRe.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia wiat consectetur adipisicing elitRe.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default About;